/** Shared Studio editor types — selection model used by the canvas overlay,
 *  the inspector, and the StudioEditor screen. */

/** "video" is inspector-only (the darken layer fills the frame — nothing to
 *  drag); the canvas overlay ignores it (no rect, no hit-testing). */
export type StudioElementId = "caption" | "logo" | "speaker" | "video";

export interface StudioSelection {
  /** Selected composition element, null = nothing (inspector shows clip basics). */
  el: StudioElementId | null;
  /** Selected caption cue (0-based index into ClipProps.cues). Only meaningful
   *  alongside el === "caption"; clicking the caption on canvas selects the
   *  cue active at the playhead, clicking a timeline chip selects that cue. */
  cueIdx: number | null;
  /** The exact word clicked inside the caption — lets the chat suggest
   *  "make THIS word gold". Undefined for non-canvas selection (panel,
   *  cue-chip) or a click that hit no word. */
  word?: string;
  /** 0-based index of that word among the caption's rendered words. */
  wordIdx?: number;
}

export const NO_SELECTION: StudioSelection = { el: null, cueIdx: null };
